export default "__VITE_ASSET__kidWDQRh__"